import axios from 'axios'
import { deepFreeze } from '../../../features/common/Utilities'
import _ from 'lodash';
import { CLIENTES_ENDPOINT } from 'cfgCommon/endpoints'

export async function getProvinceById(countryId, provinceId) {
  const response = await axios(`${CLIENTES_ENDPOINT}/countries/${countryId}/province`);
      if (response.status === 200) {
        return response.data.data.find(province => province.id === provinceId);
      }
}

export async function getLocations() {
  let locations = [];
  let locationsArray;
  const response = await axios(`${CLIENTES_ENDPOINT}/countries`);
  if (response.status === 200) {
    locationsArray = await Promise.all(response.data.data.map(async country => {
      let provinces = [];
      let provincesArray;
      const responseProvince = await axios(`${CLIENTES_ENDPOINT}/countries/${country.id}/province`);
      if (responseProvince.status === 200) {
        provincesArray = responseProvince.data.data.map(province => {
          return {
            id: province.id,
            name: province.nombre
          }
        });
      }
      provinces = _.keyBy(provincesArray, 'id');
      return {
        id: country.id,
        name: country.nombre,
        provinces,
      }
    }));

    locations = _.keyBy(locationsArray, 'id');

    return deepFreeze(locations);
  }

}